/**
 * This plugins provides functionality for template instruction text - Jira.
 * It allows opening dialog upon clicking on the instruction text in the editor.
 *
 * It comes from confuence-jira-plugin.
 */

export function placeholderJiraWRM() {
	return ['wr!confluence.extra.jira:text-placeholders-jira'];
}
